module.exports = __webpack_public_path__ + "static/img/10_預約看診.3190714.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/10_預約看診.png
// module id = KnEL
// module chunks = 1